import {PermissionCheck} from '@dofleini/security';
import React from 'react';

import {CustomExportComponent} from '@/components/CustomExportComponent';
import ProposalRequestBulkAction from '@/modules/proposalRequest/components/ProposalRequestBulkAction';
import {
  CACHE_KEY_LIST_OLD_PROPOSAL_REQUEST,
  CACHE_KEY_LIST_PROPOSAL_REQUEST,
  ROUTE_PATH_PROPOSAL_REQUEST,
  SECURITY_KEY_PROPOSAL_REQUEST,
  TRANSLATION_PREFIX_PROPOSAL_REQUEST
} from '@/modules/proposalRequest/contants/proposalRequest';
import {columns, commonColumns} from '@/modules/proposalRequest/contants/proposalRequest.columns';
import {filters} from '@/modules/proposalRequest/contants/proposalRequest.filters';
import ProposalRequestApiService from '@/modules/proposalRequest/services/ProposalRequestApiService';
import {i18n} from '@/settings';
import {createEntityContainer} from '@/utils/createEntityContainer';

const commonProps = {
  module: CACHE_KEY_LIST_PROPOSAL_REQUEST,
  route: ROUTE_PATH_PROPOSAL_REQUEST,
  useCreatePath: true,
  canAdd: false,
  rowClassName: (record) => `table-row-proposal proposal-row-${record.subjectType}`,
  translation: 'proposalRequest',
  translationPrefix: TRANSLATION_PREFIX_PROPOSAL_REQUEST,
  filters,
  columns,
  extras: <PermissionCheck permissions={'REQUEST:EXPORT_EXCEL'}>
    <CustomExportComponent
      service={ProposalRequestApiService.exportExcel}
      title={'proposalRequest.export'}
      format={'.xlsx'}
      translation={'proposalRequest'}
      documentTitle={i18n.t('proposalRequest:proposalRequest.exportFileName')}
    />
  </PermissionCheck>,
  pageConfig: {
    sort: {'createdAt': 1},
  },
  entityName: SECURITY_KEY_PROPOSAL_REQUEST,
  canSelect: true,
  breadcrumbName: 'name',
  // eslint-disable-next-line react/display-name
  selectedActions: (itemsSelected) => <ProposalRequestBulkAction {...itemsSelected}/>
};

export const {
  useList: useProposalRequestList,
  ContainerList: ProposalRequestList,
  useTablePagination: useProposalRequestPagination
} = createEntityContainer(
  {
    service: ProposalRequestApiService.search,
    ...commonProps
  }
);

export const {
  useList: useOldProposalRequestList,
  ContainerList: OldProposalRequestList,
  useTablePagination: useOldProposalRequestPagination
} = createEntityContainer(
  {
    ...commonProps,
    pageTitle: 'pageTitleOld',
    module: CACHE_KEY_LIST_OLD_PROPOSAL_REQUEST,
    service: ProposalRequestApiService.searchOld,
  }
);

export const {
  useList: useAllProposalRequestList,
  ContainerList: AllProposalRequestList,
  useTablePagination: useAllProposalRequestPagination
} = createEntityContainer(
  {
    ...commonProps,
    pageTitle: 'pageTitle',
    module: CACHE_KEY_LIST_PROPOSAL_REQUEST,
    service: ProposalRequestApiService.searchAll,
    filters: [],
    columns: commonColumns,
    extras: null
  }
);
